// Hurston: bridge native email-signup forms (footer, homepage) into the
// Klaviyo welcome flow. Fire-and-forget alongside Shopify's own customer form.
(function () {
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('email-signup__form')) return;
      var input = form.querySelector('input[name="contact[email]"]');
      if (!input || !input.value) return;
      try {
        fetch('https://superagent-1102bb04.base44.app/functions/emailCapture', {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'accept': 'application/json' },
          body: JSON.stringify({ email: input.value }),
        }).catch(function () {});
      } catch (err) {}
    },
    true
  );
})();
